var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-pb-sm layout-padding" },
    [
      _c(
        "q-field",
        { staticClass: "q-pa-md" },
        [
          _c(
            "h5",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("q-icon", { attrs: { name: "fa fa-edit", color: "primary" } }),
              _vm._v(" User Notes")
            ],
            1
          ),
          _c("q-input", {
            attrs: {
              "inverted-light": "",
              color: "grey-12",
              rows: "7",
              type: "textarea",
              "max-height": 100,
              value: _vm.userForm.USER_NOTES
            },
            on: {
              keyup: function($event) {
                $event.stopPropagation()
                _vm.updateUserForm({
                  field: "USER_NOTES",
                  value: $event.target.value
                })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }